export default function TermsOfService() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12 prose prose-sm dark:prose-invert">
      <h1>Terms of Service</h1>
      <p><em>Last updated: May 12, 2026</em></p>

      <h2>1. Acceptance</h2>
      <p>
        By creating an account or using RepairApp, you agree to these Terms of Service. If you do
        not agree, do not use the service.
      </p>

      <h2>2. Service Description</h2>
      <p>
        RepairApp is a SaaS platform for fleet and equipment maintenance management. Features include
        repair order tracking, parts ordering, preventive maintenance scheduling, and notification
        delivery via email and SMS.
      </p>

      <h2>3. SMS Notification Program</h2>
      <p>
        By checking the SMS consent box during account setup, you agree to receive automated text
        messages from RepairApp about repair orders, PM alerts, and parts order updates.
        Message frequency varies. Message and data rates may apply.
      </p>
      <p>
        You can opt out at any time by replying <strong>STOP</strong> to any SMS. For help, reply
        <strong> HELP</strong>.
      </p>
      <p>
        Consent to receive SMS is not required to use the service. You may use RepairApp with
        email-only notifications.
      </p>

      <h2>4. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the service for any unlawful purpose.</li>
        <li>Attempt to gain unauthorized access to any part of the service.</li>
        <li>Interfere with or disrupt the service or its infrastructure.</li>
        <li>Use the service to harass, abuse, or harm others.</li>
      </ul>

      <h2>5. Account Responsibilities</h2>
      <p>
        You are responsible for maintaining the confidentiality of your credentials and for all
        activity that occurs under your account. Notify us immediately of any unauthorized use.
      </p>

      <h2>6. Data and Privacy</h2>
      <p>
        Your use of the service is also governed by our{' '}
        <a href="/privacy">Privacy Policy</a>, which is incorporated into these Terms by reference.
      </p>

      <h2>7. Service Availability</h2>
      <p>
        We strive for high availability but do not guarantee uninterrupted access. We may perform
        maintenance that temporarily restricts access with or without advance notice.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, RepairApp and American Rail Center are not liable for
        indirect, incidental, or consequential damages arising from your use of the service.
      </p>

      <h2>9. Modifications</h2>
      <p>
        We may update these Terms at any time. Continued use of the service after changes constitutes
        acceptance of the revised Terms.
      </p>

      <h2>10. Contact</h2>
      <p>
        American Rail Center<br />
        <a href="mailto:support@americanrailcenter.com">support@americanrailcenter.com</a>
      </p>
    </div>
  );
}
